import useLanguageTree from '~/commons/language'
const {t} = useLanguageTree()

export default {
  name: 'file.aggregate',
  title: ({notification_name}) => {
    const args = {action: t('notification.file.shared.aggregate.creation')}
    if (notification_name === 'file.shared.deleted') {
      args.action = t('notification.file.shared.aggregate.deletion')
    }
    return t('notification.file.shared.aggregate.title', args)
  },
  icon: () => '/static/images/ipn/aggregate.png',
  click (payload) {
    this.$store.dispatch('dialog/showDialog', {
      title: 'notification.file.shared.aggregate.title',
      titleArgs: {
        action: {
          value: payload.notification_name === 'file.shared.deleted' ? 'notification.file.shared.aggregate.deletion' : 'notification.file.shared.aggregate.creation',
          needsTranslation: true
        }
      },
      body: require('~/components/common/dialog/types/DialogAggregateNotification.vue').default,
      props: {
        payload: payload
      },
      persistent: true,
      width: 550,
      actions: {
        cancel: 'Close'
      }
    })
  },
  body (payload) {
    const args = {action: t('notification.file.shared.aggregate.created')}
    if (payload.notification_name === 'file.shared.deleted') {
      args.action = t('notification.file.shared.aggregate.deleted')
    }
    const actors = payload.actors.map(x => x.actor_name)
    if (actors.length === 1) {
      args.name = actors[0]
      return t('notification.file.shared.aggregate.summary_body.actor', args)
    } else {
      args.name = actors.slice(0, 2).join(', ') + (actors.length > 2 ? ' ...' : '')
      return t('notification.file.shared.aggregate.summary_body.actors', args)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileSharedNewAggregate.js